export default "__VITE_ASSET__wRZoR$13__"